module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.isManager('project|maintenance|finance|admin')) ? _c('popup', {
    attrs: {
      "button-style": _vm.addProvider ? 'primary' : 'info',
      "heading": 'New Backhaul ' + (_vm.sharerName ? 'for ' + _vm.sharerName : (_vm.addProvider ? 'Provider' + (_vm.siteName ? ': ' + _vm.siteName : '') : 'Customer')),
      "show-text": _vm.showText,
      "button-text": _vm.addProvider ? 'Provider' : 'Customer',
      "size": "medium",
      "buttonSize": "small",
      "button-icon": "fa fa-plus",
      "disable-button": _vm.readOnly,
      "table-ref": _vm.tableRef,
      "show-cancel": false,
      "show-save": false
    },
    on: {
      "save": _vm.onCloseDialog,
      "close": _vm.onCloseDialog
    }
  }, [_c('div', {
    staticClass: "padded",
    staticStyle: {
      "clear": "both",
      "text-align": "left"
    }
  }, [(_vm.provider) ? _c('backhaul-provider', {
    attrs: {
      "id": "bkp",
      "site-id": _vm.siteId,
      "sharer-id": _vm.sharerId,
      "is-new": true,
      "edit-mode": true,
      "show-edit-button": false
    }
  }) : _c('backhaul-customer', {
    attrs: {
      "id": "bks",
      "site-id": _vm.siteId,
      "sharer-id": _vm.sharerId,
      "is-new": true,
      "edit-mode": true,
      "show-edit-buton": false
    }
  })], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b54eb58"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/actions/BackhaulAction.vue
// module id = 1514
// module chunks = 0